import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { ClockFilled } from "@fluentui/react-icons";
import React from "react";
import { DelayData } from "../../models/flights/IFlightsCommon";
import {
  formatDisplayValue,
  formatHeaderDisplayValue,
} from "../../utils/common/FormatHelper";
import CardHeader from "./CardHeader";
import { useCardStyles } from "./shared.styles";

interface DelayCardProps {
  data: DelayData;
  className?: string;
}

const DelayCard: React.FC<DelayCardProps> = ({ data, className }) => {
  const shared = useCardStyles();
  const local = useLocalStyles();

  return (
    <article
      className={mergeClasses(shared.container, local.container, className)}
    >
      <CardHeader
        icon={<ClockFilled />}
        title="Delay"
        primaryValue={formatHeaderDisplayValue(data.delayTime)}
      />

      <section className={mergeClasses(shared.content, local.content)}>
        <dl className={mergeClasses(shared.column, local.column)}>
          <div className={mergeClasses(shared.row, local.row)}>
            <dt className={mergeClasses(shared.label, local.label)}>
              Delay Code
            </dt>
            <dd className={mergeClasses(shared.value, local.value)}>
              {formatDisplayValue(data.delayCode)}
            </dd>
          </div>
          <div className={mergeClasses(shared.row, local.row)}>
            <dt className={mergeClasses(shared.label, local.label)}>
              Sub-Delay Code
            </dt>
            <dd className={mergeClasses(shared.value, local.value)}>
              {formatDisplayValue(data.subDelayCode)}
            </dd>
          </div>
          <div className={mergeClasses(shared.row, local.row)}>
            <dt className={mergeClasses(shared.label, local.label)}>
              Total Duration
            </dt>
            <dd className={mergeClasses(shared.value, local.value)}>
              {formatDisplayValue(data.delayDuration)}
            </dd>
          </div>
          <div className={mergeClasses(shared.row, local.row)}>
            <dt className={mergeClasses(shared.label, local.label)}>
              Service Type
            </dt>
            <dd className={mergeClasses(shared.value, local.value)}>
              {formatDisplayValue(data.serviceType)}
            </dd>
          </div>
          <div className={mergeClasses(shared.row, local.row)}>
            <dt className={mergeClasses(shared.label, local.label)}>
              Service Category
            </dt>
            <dd className={mergeClasses(shared.value, local.value)}>
              {formatDisplayValue(data.serviceCategory)}
            </dd>
          </div>
        </dl>
      </section>
    </article>
  );
};

export default DelayCard;

const useLocalStyles = makeStyles({
  container: {
    overflow: "hidden",
    "& > :first-child": {
      marginBottom: "4px",
    },
  },
  content: {
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "0px",
  },
  column: {
    gap: "3px",
    width: "100%",
  },
  row: {
    justifyContent: "center",
    gap: "12px",
    width: "100%",
    minHeight: "16px",
  },
  label: {
    flex: "1",
    width: "auto",
    whiteSpace: "nowrap",
    lineHeight: "1.2",
  },
  value: {
    flex: "1",
    width: "auto",
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "1.2",
  },
});
